import { render, staticRenderFns } from "./KarsilastirmaliGrafikColAyChart.vue?vue&type=template&id=2a18e5e5&scoped=true"
import script from "./KarsilastirmaliGrafikColAyChart.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaliGrafikColAyChart.vue?vue&type=script&lang=ts"
import style0 from "./KarsilastirmaliGrafikColAyChart.vue?vue&type=style&index=0&id=2a18e5e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18e5e5",
  null
  
)

export default component.exports